var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSubmenuEdit = function SvgSubmenuEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.423,
    height: 18,
    viewBox: "0 0 18.423 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#313237",
    d: "M8.606 17a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0V2H2v14h5.606a1 1 0 0 1 1 1m9.524.63a1 1 0 0 1-1.414 0l-2.33-2.33A4.46 4.46 0 0 1 12 16a4.5 4.5 0 1 1 4.5-4.5 4.46 4.46 0 0 1-.7 2.386l2.33 2.33a1 1 0 0 1 0 1.414M12 14a2.5 2.5 0 1 0-2.5-2.5A2.5 2.5 0 0 0 12 14M9 5a1 1 0 0 0-1-1H5a1 1 0 0 0 0 2h3a1 1 0 0 0 1-1M7 8a1 1 0 0 0-1-1H5a1 1 0 0 0 0 2h1a1 1 0 0 0 1-1",
    "data-name": "Path 43"
  })));
};
export default SvgSubmenuEdit;